export enum AcademyOnboardingStatus {
    STEP_1 = '1. General data',
    STEP_2 = '2. Other data',
    STEP_3 = '3. Responsibles',
    STEP_4 = '4. Stripe connection',
    STEP_5 = '5. Completed',
  }